import SectionHeading from "./SectionHeading";
import { useT } from "../i18n/useT";

export default function Engagements() {
  const t = useT();
  return (
    <section
      id="engagements"
      className="py-24 sm:py-28 border-t border-ink-800/60 bg-ink-900/30"
    >
      <div className="container-page">
        <SectionHeading
          eyebrow={t.engagements.eyebrow}
          title={t.engagements.title}
          lede={t.engagements.lede}
        />
        <ul className="mt-12 divide-y divide-ink-800/80 border-y border-ink-800/80">
          {t.engagements.items.map((e) => (
            <li
              key={e.tag}
              className="grid gap-2 py-6 sm:grid-cols-[12rem_1fr] sm:items-baseline sm:gap-10"
            >
              <span className="font-mono text-xs uppercase tracking-wider text-accent-500">
                {e.tag}
              </span>
              <p className="text-sm text-ink-200 leading-relaxed">{e.text}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
